import { useEffect, useState } from "react";
import { Form, Row, Col, InputGroup, Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { fetchSimDocumentsToken } from "../../../authentication/AuthenticationHelper";
import { fetchDocumentsByFileName } from "../../../api/simDocuments/DocumentService";
import { SelectDocumentState } from "../../../routing/RoutingStates";
import { DocumentStruct } from "../../../common/Interfaces";

export default function SearchDocument() {
  const [fileName, setFileName] = useState("");
  const [documents, setDocuments] = useState<DocumentStruct[]>([]);
  const [loadingDocuments, setLoadingDocuments] = useState(false);
  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const navigate = useNavigate();

  const handleDocumentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setErrorMessages([]);
    setFileName(event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = await fetchSimDocumentsToken();
      if (token) {
        try {
          const documentsList = await fetchDocumentsByFileName({
            fileName,
            token,
          });
          setDocuments(documentsList || []);
        } catch (error: any) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            const errors = error.response.data.errors;
            const messages = errors.map((err: any) => err.message);
            setErrorMessages(messages);
          }
        } finally {
          setLoadingDocuments(false);
        }
      }
    };

    if (loadingDocuments && fileName.length > 0) {
      fetchData();
    }
  }, [loadingDocuments, fileName]);

  useEffect(() => {
    if (!loadingDocuments && documents.length > 0) {
      const selectDocumentState: SelectDocumentState = {
        basicMachineInformationResults: [],
        documentResults: documents,
      };
      navigate("SearchDocument", {
        state: { selectDocumentState },
      });
    }
  }, [loadingDocuments, documents]);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (fileName.length > 0) {
      setLoadingDocuments(true);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="align-items-center">
        <Col xs={2}>
          <Form.Label>Search Document</Form.Label>
        </Col>
        <Col xs={4}>
          <InputGroup className="padding-top" id="search-document">
            <Form.Control
              placeholder="Enter Document"
              value={fileName}
              onChange={handleDocumentChange}
            />
          </InputGroup>
          {errorMessages.map((errorMessage, index) => (
            <label key={index} className="errorMessage">
              {errorMessage}
            </label>
          ))}
        </Col>
        <Col xs={2}>
          {loadingDocuments ? (
            <Spinner animation="border" />
          ) : (
            <Button type="submit">Search</Button>
          )}
        </Col>
      </Row>
    </Form>
  );
}
